import React, {useState} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {connect} from 'react-redux';
import {
  goToPage,
  setIsSubmit,
  setSelectedPackageRoute,
  setSelectedPackage,
  setErrorPage,
  setPopUp,
  reportDWH,
  reportAnalytics,
} from '../PremiumPackagesCatalogSlice';
import {premiumPackageActionAsync} from '../premiumPackagesCatalogAsyncThunk';
import PackageHeader from '../Partials/packageHeader/packageHeader';
import RouteDetails from '../Partials/routeDetails/routeDetails';
import PackagePrice from '../Partials/packagePrice/packagePrice';
import Footer from '../Partials/footer/footer';

const PackageRoutesPage = (props) => {
  const [isCheckedTerms, setIsCheckedTerms] = useState(false);
  const [termsError, setTermsError] = useState('');
  const [error, setError] = useState('');

  let isDisplayFooter = true;
  let btnText = 'לרכישה';
  let currentPageFunction = handlePageContinue;
  let formid = 'premiumPackagesCatalogForm';

  let purpleTitle = '';
  let boldTitle1 = '';
  let boldTitle2 = '';
  let extraBoldTitle = props.selectedPackage.cmsData?.selfCare?.title
    ? props.selectedPackage.cmsData.selfCare.title
    : props.selectedPackage.localizedName;

  useExtendedEffect((runSideEffects) => {
    if (props.selectedPackage.cmsData?.selfCare?.isShowWarning) {
      props.setPopUp({isDisplay: true, type: 'alert', text: props.selectedPackage?.cmsData?.selfCare?.warningText});
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'visibility_11',
        eventLabel: 'element_13',
      });
    }
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'visibility_12',
      eventLabel: extraBoldTitle,
    });
    props.reportDWH({actionType: 'Package Page', status: 'Ongoing', messageText: 'Package Page Displayed'});
    if (runSideEffects()) {
    }
  }, []);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      {purpleTitle && <h1 className='purple-title'>{purpleTitle}</h1>}
      {boldTitle1 && <h2 className='bold-title1'> {boldTitle1} </h2>}
      {boldTitle2 && <h2 className='bold-title2'> {boldTitle2} </h2>}
      {extraBoldTitle && <h3 className='extra-bold-title'> {extraBoldTitle} </h3>}
    </div>
  );

  let currentPageView = (
    <>
      <PackageHeader selectedPackage={props.selectedPackage} defaultImage={props.defaultImage} />
      <RouteDetails
        defaultImage={props.defaultImage}
        selectedPackage={props.selectedPackage}
        onSelectedPackage={handleOnSelectedPackage}
        selectedPackageRoute={props.selectedPackageRoute}
      />
      <PackagePrice
        isPackageRoute={true}
        packages={[props.selectedPackageRoute]}
        lawText={props.selectedPackage?.cmsData?.selfCare?.lawText}
        isCheckedTerms={isCheckedTerms}
        termsError={''}
        onClickTerms={handleOnClickTerms}
        context={props.context}
      />
    </>
  );

  return (
    <div>
      {currentPageHeadline}
      <div className='premium-packages-catalog-content'>
        <form noValidate id={formid} onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <Footer
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          errorText={error || termsError}
          formid={formid}
        />
      </div>
    </div>
  );

  function handleSubmit(event) {
    event.preventDefault();
  }

  function handleOnSelectedPackage(item) {
    setError('');
    props.setSelectedPackageRoute(item);
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_15',
      eventLabel: item.localizedName,
    });
  }

  function handlePageContinue() {
    if (props.selectedPackageRoute == null) {
      setError('עליך לבחור לפחות מסלול אחד');
      return;
    }
    if (!isCheckedTerms) {
      setTermsError('כדי להמשיך יש לאשר את תנאי החבילה');
    } else {
      setTermsError('');
      if (props.selectedSubscriber.hasDebt) {
        props.setErrorPage({isDisplay: true, id: '0', type: 'hasDebt', isOpenWorkOrder: true, description: 'has debt'});
      } else {
        props.reportAnalytics({
          eventCategory: 'premium_packages',
          eventAction: 'click_18',
          eventLabel: props.selectedPackageRoute.localizedName,
        });
        props.premiumPackageActionAsync({action: 'add'});
      }
    }
  }

  function handleOnClickTerms(isChecked) {
    setIsCheckedTerms(isChecked);
    setTermsError('');
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_17',
      eventLabel: props.selectedPackageRoute.localizedName,
    });
  }
};

const mapStateToProps = (state) => {
  return {
    defaultImage: state.premiumPackagesCatalog.epiData?.defaultImage,
    selectedPackage: state.premiumPackagesCatalog.selectedPackage,
    selectedPackageRoute: state.premiumPackagesCatalog.selectedPackageRoute,
    selectedSubscriber: state.premiumPackagesCatalog.selectedSubscriber,
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setErrorPage,
  setPopUp,
  setSelectedPackageRoute,
  setSelectedPackage,
  premiumPackageActionAsync,
  reportDWH,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageRoutesPage);
